import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Widget from './Widget';
import Facebook from './Facebook';
import Alexa from './Alexa';
import StatusPage from './StatusPage';
import $ from 'jquery';
import CustomApp from './CustomApp';
import Voice from './Voice';
import WhatsAppTabSetting from './whatsAppTabs/WhatsappTabSetting';
import Telegram from './Telegram';
import GoogleRcs from './GoogleRcs';
import Signal from './Signal';
import TelephonySetting from './TelephonySetting';
import EmailerResponderSettings from './EmailerResponderSettings';

class DistributionWidget extends Component {

  componentDidMount() {
    (function () {
      var currentPath = window.location.href;
      var path = window.origin + "/platform/projectmgmt/test-and-deploy/DistributionWidget";
      var path1 = window.origin + "/platform/projectmgmt/test-and-deploy/DistributionWidget/";
      if (currentPath === path || currentPath === path1) {
        $("#status-tab").addClass('active');

      } else if (currentPath.includes('/projectmgmt/test-and-deploy/DistributionWidget/Facebook')) {
        $("#facebook-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/test-and-deploy/DistributionWidget/Alexa')) {
        $("#alexa-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/test-and-deploy/DistributionWidget/widget')) {
        $("#widget-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/test-and-deploy/DistributionWidget/whatsapp')) {
        $("#whatsapp-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/test-and-deploy/DistributionWidget/custom-app')) {
        $("#custom-app-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/test-and-deploy/DistributionWidget/signal')) {
        $("#signal-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/test-and-deploy/DistributionWidget/telegram')) {
        $("#telegram-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/test-and-deploy/DistributionWidget/rcs')) {
        $("#rcs-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/test-and-deploy/DistributionWidget/voice')) {
        $("#voice-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/test-and-deploy/DistributionWidget/telephony-setting')) {
        $("#telephony-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/test-and-deploy/DistributionWidget/email')) {
        $("#email-tab").addClass('active');
      } $("#widget-tab,#facebook-tab,#alexa-tab,#status-tab,#whatsapp-tab,#custom-app-tab,#signal-tab,#telegram-tab,#rcs-tab,#voice-tab,#telephony-tab,#store-tab,#email-tab")
        .on("click", function () {
          $("#widget-tab,#facebook-tab,#alexa-tab,#status-tab,#whatsapp-tab,#custom-app-tab,#signal-tab,#telegram-tab,#rcs-tab,#voice-tab,#telephony-tab,#store-tab,#email-tab")
            .removeClass('active');
          localStorage.setItem("last-used-report-settings-sub-tab", $(this)[0].id);
          $(this).addClass('active')

        })

      $("#whatsapp-tab").on("click", function () {
        $("#acl-whatsapp-tab,#infobip-whatsapp-tab")
          .removeClass('active');
        $("#acl-whatsapp-tab").addClass('active');
      })

      $("#telephony-tab").on("click", function () {
        $("#basic-setting,#outreach-programs")
          .removeClass('active');
        $("#basic-setting").addClass('active');
      })

    })();
  }
  render() {
    return (

      <div id="tabPage" >
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <div className="container-fluid" style={{ marginLeft: '0px' }} >
            {/* Nav tabs */}
            <div className="tab-class" style={{ marginLeft: '10px' }}>
              <ul className="nav nav-tabs border-bottom navCluster">
                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="status-tab">
                    Launchpad
                  </li></Link>
                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/widget" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="widget-tab" >
                    Widget
                  </li></Link>
                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/signal" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="signal-tab" >
                    Signal
                  </li></Link>
                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/telegram" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="telegram-tab" >
                    Telegram
                  </li></Link>
                  <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/rcs" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="rcs-tab" >
                    Google RCS
                  </li></Link>
                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/Facebook" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="facebook-tab" >
                    Facebook
                  </li></Link>
                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/Alexa" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="alexa-tab" >
                    Alexa
                  </li></Link>
                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/whatsapp" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="whatsapp-tab" >
                    Whatsapp
                  </li></Link>
                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/custom-app" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="custom-app-tab" >
                    Custom App
                  </li></Link>
                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/voice" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="voice-tab" >Voice</li>
                </Link>
                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/telephony-setting" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="telephony-tab" >Telephony</li>
                </Link>
                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/email" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="email-tab" >Email</li>
                </Link>

              </ul>
            </div>
          </div>
        </div>
        <Switch>
        <Route path="/projectmgmt/test-and-deploy/DistributionWidget/email" component={EmailerResponderSettings}></Route>
          <Route path="/projectmgmt/test-and-deploy/DistributionWidget/telephony-setting" component={TelephonySetting}></Route>
          <Route path="/projectmgmt/test-and-deploy/DistributionWidget/voice" component={Voice}></Route>
          <Route path="/projectmgmt/test-and-deploy/DistributionWidget/telegram" component={Telegram}></Route>
          <Route path="/projectmgmt/test-and-deploy/DistributionWidget/rcs" component={GoogleRcs}></Route>
          <Route path="/projectmgmt/test-and-deploy/DistributionWidget/signal" component={Signal}></Route>
          <Route path="/projectmgmt/test-and-deploy/DistributionWidget/custom-app" component={CustomApp}></Route>
          <Route path="/projectmgmt/test-and-deploy/DistributionWidget/whatsapp" component={WhatsAppTabSetting}></Route>
          <Route path="/projectmgmt/test-and-deploy/DistributionWidget/Alexa" component={Alexa}></Route>
          <Route path="/projectmgmt/test-and-deploy/DistributionWidget/Facebook" component={Facebook}></Route>
          <Route path="/projectmgmt/test-and-deploy/DistributionWidget/widget" component={Widget}></Route>
          <Route path="/projectmgmt/test-and-deploy/DistributionWidget" component={StatusPage}></Route>

        </Switch>
      </div>

    );
  }
}
export default DistributionWidget;


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/DistributionWidget.js